const { onlyAlphaNumeric, SPACE } = require('../helpers');

const regEx = /^HR-[0-9]{5}$/;

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyAlphaNumeric(zipCode);
  if (zipCode.length <= 2) {
    return zip;
  }
  return `${zip.slice(0, 2).toUpperCase()}-${zip.slice(2, 7)}`;
};

exports.countryDefinition = {
  country: 'Croatia',
  code: 'HR',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['zipCode', 'city']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(regEx),
      error: 'Must be HR+5 numbers, HR-10000'
    }
  ]
};
